export const GoogleRMKT = {
  enable() {
    let script = document.createElement("script"); // NOSONAR
    script.type = "text/javascript";
    script.src = "//www.googleadservices.com/pagead/conversion_async.js";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  init() {},
  wait() {
    return !!window.google_trackConversion;
  },
  enviar() {
    window.google_trackConversion({
      google_conversion_id: 852963001,
      google_custom_params: window.google_tag_params,
      google_remarketing_only: true,
    });
  },
  simulacion() {
    window.google_tag_params = {
      Categoría: "No cliente",
      Pasos: "Paso 1",
    };
  },
  cliente() {
    window.google_tag_params = {
      Categoría: "Plazo Fijo",
      Pasos: "Ya sos cliente",
    };
  },
  noCliente() {
    window.google_tag_params = {
      Categoría: "No cliente",
      Pasos: "Paso 1",
    };
  },
  datosPersonales() {
    window.google_tag_params = {
      Categoría: "No cliente",
      Pasos: "Paso 2",
    };
  },
  datosLaborales() {
    window.google_tag_params = {
      Categoría: "No cliente",
      Pasos: "Paso 3",
    };
  },
  activity() {
    window.google_tag_params = {
      Categoría: "No cliente",
      Pasos: "Paso 4",
    };
  },
  datosCuenta() {
    window.google_tag_params = {
      Categoría: "No cliente",
      Pasos: "Paso 5",
    };
  },
  confirmacion() {
    window.google_tag_params = {
      Categoría: "No cliente",
      Pasos: "Paso 6",
    };
  },
  thank() {
    window.google_tag_params = {
      Categoría: "No cliente",
      Pasos: "Paso 7",
    };
  },
};

export const GoogleSiteTag = {
  enable() {
    let script = document.createElement("script"); // NOSONAR
    script.type = "text/javascript";
    script.onload = function () {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
    };
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-852963001";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  wait() {
    return !!window.gtag;
  },
  landing() {
    window.gtag("js", new Date());
    window.gtag("config", "AW-852963001");
  },
  snippetPaso1() {
    window.gtag("event", "conversion", {
      send_to: "AW-852963001/ZP2ZCIm_pKcBELnd3JYD",
    });
  },
  snippetPaso2() {
    window.gtag("event", "conversion", {
      send_to: "AW-852963001/lH8TCLXzh9QBELnd3JYD",
    });
  },
  snippetPaso3() {
    window.gtag("event", "conversion", {
      send_to: "AW-852963001/XNPKCL_VqacBELnd3JYD",
    });
  },
  snippetPaso4() {
    window.gtag("event", "conversion", {
      send_to: "AW-852963001/zkDWCI-HsKcBELnd3JYD",
    });
  },
  snippetPaso5() {
    window.gtag("event", "conversion", {
      send_to: "AW-852963001/IF5eCKiIsKcBELnd3JYD",
    });
  },
  snippetPaso6() {
    window.gtag("event", "conversion", {
      send_to: "AW-852963001/oveYCMXVqacBELnd3JYD",
    });
  },
  snippetPaso7() {
    window.gtag("event", "conversion", {
      send_to: "AW-852963001/3a5oCOzCi60BELnd3JYD",
    });
  },
  snippetThank() {
    window.gtag("event", "conversion", {
      send_to: "AW-852963001/k_8dCPuKsKcBELnd3JYD",
    });
  },
  snippetCliente() {
    window.gtag("event", "conversion", {
      send_to: "AW-852963001/ZzpECMCWkNQBELnd3JYD",
    });
  },
};
